import React, { useState, useEffect } from 'react';

function EditUserModal({ user, onClose, onSubmit, loading = false }) {
  const [formData, setFormData] = useState({
    display_name: user?.display_name || '',
    role: user?.role || 'user'
  });

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && !loading) {
        onClose();
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [loading, onClose]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const submitData = {
      display_name: formData.display_name?.trim() || null,
      role: formData.role
    };

    onSubmit(submitData);
  };

  const handleBackdropClick = () => {
    if (!loading) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]"
      onClick={handleBackdropClick}
    >
      <div 
        className="rounded-lg p-6 w-[90%] max-w-md max-h-[90vh] overflow-auto bg-white dark:bg-slate-800"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="m-0 mb-5 text-xl font-semibold text-gray-800 dark:text-slate-100">
          Edit User
        </h3>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-1.5 text-sm font-medium text-gray-700 dark:text-slate-300">
              Display name
            </label>
            <input
              type="text"
              value={formData.display_name}
              onChange={(e) => setFormData({ ...formData, display_name: e.target.value })}
              className="w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300 dark:border-white/20 bg-white dark:bg-slate-900 text-gray-900 dark:text-slate-100 placeholder-gray-500 dark:placeholder-slate-500"
              placeholder="Full name"
            />
            <p className="text-xs mt-1 text-gray-500 dark:text-slate-400">
              Optional. User's full name for display purposes.
            </p>
          </div>

          <div className="mb-4">
            <label className="block mb-1.5 text-sm font-medium text-gray-700 dark:text-slate-300">
              Role *
            </label>
            <select
              value={formData.role}
              onChange={(e) => setFormData({ ...formData, role: e.target.value })}
              className="w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border-gray-300 dark:border-white/20 bg-white dark:bg-slate-900 text-gray-900 dark:text-slate-100"
            >
              <option value="user" className="bg-white dark:bg-slate-800">User</option>
              <option value="manager" className="bg-white dark:bg-slate-800">Manager</option>
              <option value="admin" className="bg-white dark:bg-slate-800">Admin</option>
            </select>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 justify-end">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="w-full sm:w-auto px-4 sm:px-5 py-2 sm:py-2.5 border-none rounded-md cursor-pointer font-medium text-xs sm:text-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed bg-gray-500 dark:bg-slate-700 text-white dark:text-slate-100 hover:bg-gray-600 dark:hover:bg-slate-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="w-full sm:w-auto px-4 sm:px-5 py-2 sm:py-2.5 bg-blue-500 text-white border-none rounded-md cursor-pointer font-medium text-xs sm:text-sm hover:bg-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
            >
              {loading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Updating...
                </>
              ) : (
                'Update'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditUserModal;